import React from "react";

const SeoOptimize = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.18913 32.5H34.7881C38.7781 32.5 40.8781 30.4 40.8781 26.41V1H3.07812V26.41C3.09913 30.4 5.19913 32.5 9.18913 32.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 1H43"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6016 43L22.0016 38.8M22.0016 38.8V32.5M22.0016 38.8L30.4016 43"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M12.5469 19.9001L19.1619 14.3771C19.6869 13.9361 20.3799 14.0621 20.7369 14.6501L23.2569 18.8501C23.6139 19.4381 24.3069 19.5431 24.8319 19.1231L31.4469 13.6001"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SeoOptimize;
